export var ButtonStatus;
(function (ButtonStatus) {
    ButtonStatus[ButtonStatus["Up"] = 0] = "Up";
    ButtonStatus[ButtonStatus["Down"] = 1] = "Down";
    ButtonStatus[ButtonStatus["Over"] = 2] = "Over";
    ButtonStatus[ButtonStatus["SelectedOver"] = 3] = "SelectedOver";
    ButtonStatus[ButtonStatus["Disabled"] = 4] = "Disabled";
    ButtonStatus[ButtonStatus["SelectedDisabled"] = 5] = "SelectedDisabled";
})(ButtonStatus || (ButtonStatus = {}));
export var AlignType;
(function (AlignType) {
    AlignType[AlignType["Left"] = 0] = "Left";
    AlignType[AlignType["Center"] = 1] = "Center";
    AlignType[AlignType["Right"] = 2] = "Right";
    AlignType[AlignType["None"] = 3] = "None";
})(AlignType || (AlignType = {}));
export var VAlignType;
(function (VAlignType) {
    VAlignType[VAlignType["Top"] = 0] = "Top";
    VAlignType[VAlignType["Middle"] = 1] = "Middle";
    VAlignType[VAlignType["Bottom"] = 2] = "Bottom";
    VAlignType[VAlignType["None"] = 3] = "None";
})(VAlignType || (VAlignType = {}));
export var LayoutChangedReason;
(function (LayoutChangedReason) {
    LayoutChangedReason[LayoutChangedReason["Size"] = 0] = "Size";
    LayoutChangedReason[LayoutChangedReason["Pos"] = 1] = "Pos";
    LayoutChangedReason[LayoutChangedReason["Visible"] = 2] = "Visible";
    LayoutChangedReason[LayoutChangedReason["Hierarchy"] = 3] = "Hierarchy";
})(LayoutChangedReason || (LayoutChangedReason = {}));
export var ButtonMode;
(function (ButtonMode) {
    ButtonMode[ButtonMode["Common"] = 0] = "Common";
    ButtonMode[ButtonMode["Check"] = 1] = "Check";
    ButtonMode[ButtonMode["Radio"] = 2] = "Radio";
})(ButtonMode || (ButtonMode = {}));
export var ButtonDownEffect;
(function (ButtonDownEffect) {
    ButtonDownEffect[ButtonDownEffect["None"] = 0] = "None";
    ButtonDownEffect[ButtonDownEffect["Dark"] = 1] = "Dark";
    ButtonDownEffect[ButtonDownEffect["UpScale"] = 2] = "UpScale";
    ButtonDownEffect[ButtonDownEffect["DownScale"] = 3] = "DownScale";
})(ButtonDownEffect || (ButtonDownEffect = {}));
export var TextFitContent;
(function (TextFitContent) {
    TextFitContent[TextFitContent["None"] = 0] = "None";
    TextFitContent[TextFitContent["Both"] = 1] = "Both";
    TextFitContent[TextFitContent["Height"] = 2] = "Height";
})(TextFitContent || (TextFitContent = {}));
export var LayoutType;
(function (LayoutType) {
    LayoutType[LayoutType["None"] = 0] = "None";
    LayoutType[LayoutType["SingleColumn"] = 1] = "SingleColumn";
    LayoutType[LayoutType["SingleRow"] = 2] = "SingleRow";
    LayoutType[LayoutType["FlowX"] = 3] = "FlowX";
    LayoutType[LayoutType["FlowY"] = 4] = "FlowY";
})(LayoutType || (LayoutType = {}));
export var StretchMode;
(function (StretchMode) {
    StretchMode[StretchMode["None"] = 0] = "None";
    StretchMode[StretchMode["Stretch"] = 1] = "Stretch";
    StretchMode[StretchMode["ResizeToFit"] = 2] = "ResizeToFit";
})(StretchMode || (StretchMode = {}));
export var SelectionMode;
(function (SelectionMode) {
    SelectionMode[SelectionMode["None"] = 0] = "None";
    SelectionMode[SelectionMode["Single"] = 1] = "Single";
    SelectionMode[SelectionMode["Multiple"] = 2] = "Multiple";
    SelectionMode[SelectionMode["MultipleBySingleClick"] = 3] = "MultipleBySingleClick";
    SelectionMode[SelectionMode["Disabled"] = 4] = "Disabled";
})(SelectionMode || (SelectionMode = {}));
export var LoaderFitMode;
(function (LoaderFitMode) {
    LoaderFitMode[LoaderFitMode["None"] = 0] = "None";
    LoaderFitMode[LoaderFitMode["Fill"] = 1] = "Fill";
    LoaderFitMode[LoaderFitMode["Contain"] = 2] = "Contain";
    LoaderFitMode[LoaderFitMode["Cover"] = 3] = "Cover";
    LoaderFitMode[LoaderFitMode["CoverWidth"] = 4] = "CoverWidth";
    LoaderFitMode[LoaderFitMode["CoverHeight"] = 5] = "CoverHeight";
})(LoaderFitMode || (LoaderFitMode = {}));
export var ProgressTitleType;
(function (ProgressTitleType) {
    ProgressTitleType[ProgressTitleType["Percent"] = 0] = "Percent";
    ProgressTitleType[ProgressTitleType["ValueAndMax"] = 1] = "ValueAndMax";
    ProgressTitleType[ProgressTitleType["Value"] = 2] = "Value";
    ProgressTitleType[ProgressTitleType["Max"] = 3] = "Max";
})(ProgressTitleType || (ProgressTitleType = {}));
export var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection[ScrollDirection["Vertical"] = 0] = "Vertical";
    ScrollDirection[ScrollDirection["Horizontal"] = 1] = "Horizontal";
    ScrollDirection[ScrollDirection["Both"] = 2] = "Both";
})(ScrollDirection || (ScrollDirection = {}));
export var ScrollTouchEffect;
(function (ScrollTouchEffect) {
    ScrollTouchEffect[ScrollTouchEffect["Default"] = 0] = "Default";
    ScrollTouchEffect[ScrollTouchEffect["On"] = 1] = "On";
    ScrollTouchEffect[ScrollTouchEffect["Off"] = 2] = "Off";
})(ScrollTouchEffect || (ScrollTouchEffect = {}));
export var ScrollBounceBackEffect;
(function (ScrollBounceBackEffect) {
    ScrollBounceBackEffect[ScrollBounceBackEffect["Default"] = 0] = "Default";
    ScrollBounceBackEffect[ScrollBounceBackEffect["On"] = 1] = "On";
    ScrollBounceBackEffect[ScrollBounceBackEffect["Off"] = 2] = "Off";
})(ScrollBounceBackEffect || (ScrollBounceBackEffect = {}));
export var ScrollBarDisplay;
(function (ScrollBarDisplay) {
    ScrollBarDisplay[ScrollBarDisplay["Default"] = 0] = "Default";
    ScrollBarDisplay[ScrollBarDisplay["Always"] = 1] = "Always";
    ScrollBarDisplay[ScrollBarDisplay["OnOverflow"] = 2] = "OnOverflow";
    ScrollBarDisplay[ScrollBarDisplay["OnScroll"] = 3] = "OnScroll";
    ScrollBarDisplay[ScrollBarDisplay["OnOverflowAndScroll"] = 4] = "OnOverflowAndScroll";
    ScrollBarDisplay[ScrollBarDisplay["Hidden"] = 5] = "Hidden";
})(ScrollBarDisplay || (ScrollBarDisplay = {}));
export var PopupDirection;
(function (PopupDirection) {
    PopupDirection[PopupDirection["Auto"] = 0] = "Auto";
    PopupDirection[PopupDirection["Up"] = 1] = "Up";
    PopupDirection[PopupDirection["Down"] = 2] = "Down";
})(PopupDirection || (PopupDirection = {}));
export var TreeClickToExpandType;
(function (TreeClickToExpandType) {
    TreeClickToExpandType[TreeClickToExpandType["None"] = 0] = "None";
    TreeClickToExpandType[TreeClickToExpandType["SingleClick"] = 1] = "SingleClick";
    TreeClickToExpandType[TreeClickToExpandType["DoubleClick"] = 2] = "DoubleClick";
})(TreeClickToExpandType || (TreeClickToExpandType = {}));
export var RelationType;
(function (RelationType) {
    RelationType[RelationType["Width"] = 1] = "Width";
    RelationType[RelationType["Height"] = 2] = "Height";
    RelationType[RelationType["Left_Left"] = 3] = "Left_Left";
    RelationType[RelationType["Left_Center"] = 4] = "Left_Center";
    RelationType[RelationType["Left_Right"] = 5] = "Left_Right";
    RelationType[RelationType["Center_Center"] = 6] = "Center_Center";
    RelationType[RelationType["Right_Left"] = 7] = "Right_Left";
    RelationType[RelationType["Right_Center"] = 8] = "Right_Center";
    RelationType[RelationType["Right_Right"] = 9] = "Right_Right";
    RelationType[RelationType["Top_Top"] = 10] = "Top_Top";
    RelationType[RelationType["Top_Middle"] = 11] = "Top_Middle";
    RelationType[RelationType["Top_Bottom"] = 12] = "Top_Bottom";
    RelationType[RelationType["Middle_Middle"] = 13] = "Middle_Middle";
    RelationType[RelationType["Bottom_Top"] = 14] = "Bottom_Top";
    RelationType[RelationType["Bottom_Middle"] = 15] = "Bottom_Middle";
    RelationType[RelationType["Bottom_Bottom"] = 16] = "Bottom_Bottom";
    RelationType[RelationType["LeftExt_Left"] = 17] = "LeftExt_Left";
    RelationType[RelationType["LeftExt_Right"] = 18] = "LeftExt_Right";
    RelationType[RelationType["RightExt_Left"] = 19] = "RightExt_Left";
    RelationType[RelationType["RightExt_Right"] = 20] = "RightExt_Right";
    RelationType[RelationType["TopExt_Top"] = 21] = "TopExt_Top";
    RelationType[RelationType["TopExt_Bottom"] = 22] = "TopExt_Bottom";
    RelationType[RelationType["BottomExt_Top"] = 23] = "BottomExt_Top";
    RelationType[RelationType["BottomExt_Bottom"] = 24] = "BottomExt_Bottom";
    RelationType[RelationType["Size"] = 100] = "Size";
    RelationType[RelationType["Pos"] = 101] = "Pos";
    RelationType[RelationType["CenterAndMiddle"] = 102] = "CenterAndMiddle";
})(RelationType || (RelationType = {}));
